import React from "react";
import MyDateTime from "../DTechComp/MyDateTime";

// רשימת שעות לבחירה להזמנה עתידית - גריד פשוט של 4 בשורה, בסגנון
// TimesListSelections.js בהזמנת שולחן, אבל עובד ישירות על אובייקטי Date
// (לא מחרוזות "HH:mm") כדי לשמור על החוזה הקיים מול OrderTypeSelect.
// props: slots ({time:Date, afterMidnight:bool}[]), selectedSlot (Date|null), onSelect(slot: Date)
const FutureTimeList = (props) => {

    const slots = props.slots || [];
    const selectedSlot = props.selectedSlot;

    if (slots.length === 0) {
        return <div className={"regular centerText"}>אין שעות זמינות בתאריך זה</div>;
    }

    //השוואה לפי דקה (שנה/חודש/יום/שעה/דקה) ולא getTime() מדויק - selectedSlot
    //שמגיע מ-order.scheduledFor (ISO string, אחרי round-trip) יכול להיבדל
    //ב-slot שנוצר טרי ע"י generateFutureSlots במילישניות/שניות, גם כשמדובר
    //באותה משבצת 15 דק' בפועל
    const isSameSlot = (a, b) => a && b &&
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate() &&
        a.getHours() === b.getHours() &&
        a.getMinutes() === b.getMinutes();

    //מפריד מקווקו (בלי כותרת תאריך - ללקוח לא מציגים איזה יום עסקים/משמרת
    //זה, רק את חלוקת השעות בתוך התאריך שהוא ביקש) מוצג בכל מעבר בין
    //afterMidnight ל-!afterMidnight, לא לפני idx=0 (כלום לא קדם לו).
    return (
        <div className={"futureSlotsGrid"}>
            {slots.map((slot, idx) => {
                const isSelected = isSameSlot(selectedSlot, slot.time);
                const prevSlot = slots[idx - 1];
                const showDivider = idx > 0 && !!prevSlot && prevSlot.afterMidnight !== slot.afterMidnight;
                return (
                    <React.Fragment key={idx}>
                        {showDivider &&
                            <div className={"futureSlotsDivider"} aria-hidden="true" />
                        }
                        <button type="button"
                            className={`btnReset futureSlotBtn ${isSelected ? "selected" : ""}`}
                            onClick={() => props.onSelect(slot.time)}>
                            {MyDateTime.getShortTime(slot.time)}
                        </button>
                    </React.Fragment>
                );
            })}
        </div>
    );
}

export default FutureTimeList;
